<template>
  <div>
    <h1>Fournisseurs Hors Référencement</h1>
    <div class="d-flex justify-content-between align-items-center">
      <div class="buttons-container">
        <button @click="modalOpen=true">Créer un nouveau fournisseur</button>
        <button v-if="$store.state.self.isAdmin && !merging" @click="merging=true">Fusionner des fournisseurs</button>
        <button v-if="merging" @click="merging=false;selectedBaseMergeFrs=null;selectedMergeFrs=[]">Annuler la fusion</button>
        <button v-if="merging && selectedBaseMergeFrs && selectedMergeFrs.length > 0" @click="merge">Valider la fusion</button>
      </div>
      <div>
        <a v-if="$store.state.self.isAdmin" href="/static/Documentation Fournisseur HR CMEM.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
        <a v-else href="/static/Documentation Fournisseur HR.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
        <button class="btn btn-success" @click="exportDatas">Exporter les données</button>
      </div>
    </div>
    <small v-if="merging">Cliquez sur une ligne pour sélectionner un fournisseur à fusionner (le premier sélectionné sera celui dont les données seront sauvegardées)</small>
    <vue-good-table :columns="columns"
                    :rows="rows"
                    @on-row-click="onRowClick"
                    :row-style-class="rowClassFn"
                    :sort-options="{enabled: true, initialSortBy: {field: 'Nom', type: 'asc'}}">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'Contact'">
          <button class="btn btn-success" @click="selectedContactFrsHRId=props.row.Id;contactModalOpen=true"><font-awesome-icon icon="users"></font-awesome-icon></button>
        </span>
        <span v-else-if="props.column.field == 'Valide'">
          <input type="checkbox" :checked="props.row[props.column.field]" disabled="disabled" />
        </span>
        <span v-else-if="props.column.field == 'CanEdit'">
          <button class="btn btn-warning" v-if="props.row[props.column.field]" @click="selectedUpdateFrs = props.row;modalOpen = true"><font-awesome-icon icon="pen"></font-awesome-icon></button>
        </span>
        <span v-else-if="props.column.field == 'CanDelete'">
          <button class="btn btn-danger" v-if="props.row[props.column.field]" @click="deleteFrs(props.row.Id)"><font-awesome-icon icon="trash"></font-awesome-icon></button>
        </span>
      </template>
    </vue-good-table>
    <FrsHRContactModal v-if="selectedContactFrsHRId !== null" :idFrsHR="selectedContactFrsHRId" :open="contactModalOpen" @close="contactModalOpen = false; selectedContactFrsHRId = null"></FrsHRContactModal>
    <CreateFrsHRModal v-if="modalOpen"
                      :open="modalOpen"
                      @close="selectedUpdateFrs={};modalOpen=false"
                      @submitted="selectedUpdateFrs={};modalOpen=false;fetchData()"
                      :familles="families"
                      :sousFamilles="subFamilies"
                      :pIdFrsHR="selectedUpdateFrs.Id"
                      :pNom="selectedUpdateFrs.Nom"
                      :pIdFamille="selectedUpdateFrs.FamilleId"
                      :pIdSousFamille="selectedUpdateFrs.SousFamilleId"
                      :pVille="selectedUpdateFrs.Ville"
                      :pCodePostal="selectedUpdateFrs.CodePostal"
                      :pSiret="selectedUpdateFrs.Siret"
                      :pGroupeGuidList="selectedUpdateFrs.GroupeGuidList"
                      :pValide="selectedUpdateFrs.Valide"
                      ></CreateFrsHRModal>
  </div>
</template>

<script>
  import CreateFrsHRModal from "@/components/CreateFrsHRModal";
  import FrsHRContactModal from "@/components/FrsHRContactModal";

  import { getAllFrsHR, mergeFrsHR, deleteFrsHR } from "@/utils/frsHR"
  import { getNomenclatureByLevel } from "@/utils/frs"

  import { exportExcel } from "@/utils/exportExcel"

  export default {
    name: "FrsHR",
    components: {
      CreateFrsHRModal,
      FrsHRContactModal
    },
    data() {
      return {
        modalOpen: false,
        rows: [],
        families: [],
        subFamilies: [],
        selectedUpdateFrs: {},
        selectedContactFrsHRId: null,
        merging: false,
        selectedMergeFrs: [],
        selectedBaseMergeFrs: null
      }
    },
    mounted() {
      let p1 = getNomenclatureByLevel(1);
      let p2 = getNomenclatureByLevel(2);
      p1.then(res => this.families = res)
      p2.then(res => this.subFamilies = res)

      // On récupère toutes les informations nomenclatures puis ensuite, on récupère les données des frs hors référencement
      Promise.all([p1, p2]).then(this.fetchData)
    },
    computed: {
      columns() {
        const res = [
          { label: "", field: "Contact" },
          { label: "Nom", field: "Nom", filterOptions: { enabled: true, } },
          { label: "Famille", field: "Famille", filterOptions: { enabled: true, } },
          { label: "Sous Famille", field: "SousFamille", filterOptions: { enabled: true, } },
          { label: "Ville", field: "Ville", filterOptions: { enabled: true, } },
          { label: "Code Postal", field: "CodePostal", filterOptions: { enabled: true, } },
          { label: "Siret", field: "Siret", filterOptions: { enabled: true, } },
          { label: "Valide", field: "Valide", type: "boolean", filterOptions: { enabled: true, } },
          { label: "", field: "CanEdit" },
          { label: "", field: "CanDelete" },
        ]
        if (this.merging) return res.slice(0, 8) // On affiche pas les boutons modifier/supprimer
        else if (!this.$store.state.self.isAdmin) return res.slice(0, 9) // On affiche pas le bouton supprimer
        return res
      },
    },
    methods: {
      fetchData() {
        getAllFrsHR().then(res => {
          res.forEach(frs => {
            const family = this.families.find(el => el.Id == frs.FamilleId)
            frs.Famille = family ? family.Libelle : "Aucune"
            const subFamily = this.subFamilies.find(el => el.Id == frs.SousFamilleId)
            frs.SousFamille = subFamily ? subFamily.Libelle : "Aucune"
            frs.CanEdit = this.$store.state.self.isAdmin || (frs.Valide == false && frs.GroupeGuidList.length == 1)
            frs.CanDelete = this.$store.state.self.isAdmin
            //frs.Contact = true
          })
          this.rows = res
        });
      },
      rowClassFn(row) { // On met dynamiquement la classe à la ligne selon si le frs est sélectionné pour la fusion ou non
        if (row.Id == this.selectedBaseMergeFrs) return "merge-base"
        if (this.selectedMergeFrs.indexOf(row.Id) !== -1) return "merge-alt"
        return ""
      },
      // On gère le click sur la ligne pour ajouter/enlever le frs de la fusion
      onRowClick(params) {
        if (this.merging) {
          const i = this.selectedMergeFrs.indexOf(params.row.Id);

          if (params.row.Id == this.selectedBaseMergeFrs) { // On dé-sélectionne le frs de base
            this.selectedBaseMergeFrs = null;
          }
          else if (i !== -1) { // On dé-sélectionne un frs alt
            this.selectedMergeFrs = [...this.selectedMergeFrs.slice(0, i), ...this.selectedMergeFrs.slice(i + 1)]
          }
          else if (!this.selectedBaseMergeFrs) { // On sélectionne le frs de base
            this.selectedBaseMergeFrs = params.row.Id;
          }
          else { // On sélectionne un frs alt
            this.selectedMergeFrs.push(params.row.Id);
          }
        }
      },
      deleteFrs(frsId) {
        const validation = window.confirm("Voulez-vous vraiment supprimer ce fournisseur ?");
        if (validation) deleteFrsHR(frsId).then(() => this.fetchData());
      },
      merge() {
        const validation = window.confirm("Voulez-vous vraiment fusionner ces fournisseurs ?")
        if (validation) {
          mergeFrsHR(this.selectedBaseMergeFrs, this.selectedMergeFrs).then(() => {
            this.merging = false;
            this.selectedBaseMergeFrs = null;
            this.selectedMergeFrs = [];
            this.fetchData();
          })
        }
      },
      exportDatas() {
        exportExcel(this.columns, this.rows, "Fournisseurs Hors Référencement")
      }
    }
  }
</script>

<style scoped>
  .buttons-container {
      display: flex;
      margin-top: 28px;
      margin-bottom: 12px;
      column-gap: 12px;
  }
</style>
<style>
  .merge-base {
    background-color: rgba(64, 250, 64, 0.2) !important;
  }
  .merge-alt {
    background-color: rgba(255, 180, 64, 0.4) !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/FrsHR.vue